export enum Roles {
  Edit = 'Edit',
  Admin = 'Admin',
  AdminManager = 'AdminManager',
  Read = 'Read',
  None = 'None',
}
